import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import axios from 'axios';
import { useAuth } from '../AuthProvider';
import AdminNav from './AdminNav';

const API_BASE = process.env.REACT_APP_API_BASE_URL || 'http://localhost:8000';

const ProjectStatusPage = () => {
  const navigate = useNavigate();
  const { token } = useAuth();
  const [statuses, setStatuses] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    if (!token) return;
    axios.get(`${API_BASE}/admin/project-statuses`, { headers: { Authorization: `Bearer ${token}` } })
      .then((res) => setStatuses(res.data?.statuses || []))
      .catch((err) => setError(err.response?.data?.detail || 'Failed to load project statuses.'))
      .finally(() => setLoading(false));
  }, [token]);

  return (
    <div className="h-full w-full overflow-y-auto bg-gray-100 dark:bg-neutral-950 p-8">
      <div className="max-w-6xl mx-auto pb-12">
        <div className="flex justify-between items-center mb-8">
          <div>
            <h1 className="text-foreground text-3xl font-medium">Project Status</h1>
            <p className="text-muted-foreground text-sm mt-2">
              Workflow statuses for all project types (synopsis, transcription, keyword). Read-only reference.
            </p>
          </div>
          <button
            onClick={() => navigate('/')}
            className="text-muted-foreground hover:text-foreground text-sm font-medium whitespace-nowrap border border-border rounded-lg px-3 py-1.5 hover:bg-muted transition-colors"
          >
            ← Back to App
          </button>
        </div>

        <AdminNav />

        {error && (
          <div className="bg-destructive/10 border border-destructive/30 rounded-lg p-4 mb-6 text-destructive">{error}</div>
        )}

        {loading ? (
          <div className="text-muted-foreground">Loading statuses...</div>
        ) : (
          <div className="bg-white dark:bg-neutral-900 rounded-lg shadow border border-border overflow-hidden">
            <table className="min-w-full divide-y divide-border">
              <thead className="bg-muted/50 dark:bg-neutral-800">
                <tr>
                  <th className="px-4 py-3 text-left text-xs font-medium text-muted-foreground uppercase tracking-wider">Code</th>
                  <th className="px-4 py-3 text-left text-xs font-medium text-muted-foreground uppercase tracking-wider">Display name</th>
                  <th className="px-4 py-3 text-left text-xs font-medium text-muted-foreground uppercase tracking-wider">Who</th>
                  <th className="px-4 py-3 text-left text-xs font-medium text-muted-foreground uppercase tracking-wider">Preceding action</th>
                  <th className="px-4 py-3 text-left text-xs font-medium text-muted-foreground uppercase tracking-wider">Subsequent UI feature</th>
                  <th className="px-4 py-3 text-left text-xs font-medium text-muted-foreground uppercase tracking-wider">Order</th>
                </tr>
              </thead>
              <tbody className="divide-y divide-border">
                {statuses.length === 0 ? (
                  <tr><td colSpan={6} className="px-4 py-8 text-center text-muted-foreground">No statuses found.</td></tr>
                ) : (
                  statuses.map((s) => (
                    <tr key={s.code} className="hover:bg-muted/30">
                      <td className="px-4 py-3 text-sm font-mono text-foreground">{s.code}</td>
                      <td className="px-4 py-3 text-sm text-foreground">{s.display_name}</td>
                      <td className="px-4 py-3 text-sm text-muted-foreground">{s.who || '—'}</td>
                      <td className="px-4 py-3 text-sm text-muted-foreground max-w-xs truncate" title={s.preceding_action}>{s.preceding_action || '—'}</td>
                      <td className="px-4 py-3 text-sm text-muted-foreground max-w-xs truncate" title={s.subsequent_ui_feature}>{s.subsequent_ui_feature || '—'}</td>
                      <td className="px-4 py-3 text-sm text-muted-foreground">{s.sort_order}</td>
                    </tr>
                  ))
                )}
              </tbody>
            </table>
          </div>
        )}
      </div>
    </div>
  );
};

export default ProjectStatusPage;
